import { SendHorizonal } from 'lucide-react';

import {
  PromptInput,
  PromptInputBody,
  PromptInputSubmit,
  PromptInputTextarea,
} from '@/modules/ui/components/prompt-input/PromptInput';

interface CopilotSenderProps {
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: (value: string) => void;
}

export const CopilotSender = ({ isLoading, onSubmit }: CopilotSenderProps) => {
  const handleSubmit = (
    message: { text?: string },
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    event.preventDefault();

    const text = message.text?.trim();
    const hasText = Boolean(text);
    if (!hasText) {
      return;
    }

    onSubmit(text ?? '');
    // reset the textarea value
    event.currentTarget.reset();
  };

  return (
    <PromptInput
      className="boder-1 border-primary-600 bg-[#fff]"
      onSubmit={handleSubmit}
      autoFocus
    >
      <PromptInputBody>
        <div className="flex items-center gap-2">
          <PromptInputTextarea placeholder="Let me help you find the best candidates" />
          <PromptInputSubmit
            status={isLoading ? 'submitted' : undefined}
            className="mr-2 h-8 w-8"
          >
            <SendHorizonal size={18} />
          </PromptInputSubmit>
        </div>
      </PromptInputBody>
    </PromptInput>
  );
};
